import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './translation.ts';
import LanguageDetector from 'i18next-browser-languagedetector';

// Detect browser language manually
const browserLang = navigator.language || navigator.languages?.[0] || 'en';
const normalizedLang = browserLang.toLowerCase().startsWith('de') ? 'de' : 'en';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: translations,
        lng: normalizedLang, // 👈 this is your controlled initial language
        fallbackLng: 'en',
        debug: true,
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['navigator'], // still okay for fallback use
            caches: [], // disable cookies/localStorage
        },
    });

export default i18n;